<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Edit Journal Entry</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" md="3">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.StartDate"
                  label="From"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="record.StartDate"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" md="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.EndDate"
                  label="To"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="record.EndDate"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" xs="6" md="3">
            <v-btn color="accent" :loading="loader" @click="getReport"
              >Query Data</v-btn
            >
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <v-text-field dense label="Search" v-model="search"></v-text-field>
          </v-col>

          <v-divider></v-divider>

          <v-col cols="12">
            <v-data-table
              :mobile-breakpoint="zeroValue"
              :headers="headers"
              :items="reportData"
              :search="search"
            >
              <template v-slot:item.action="{ item }">
                <v-btn
                  icon
                  text
                  color="primary"
                  :to="`/edit/journal/entry/${item.id}`"
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
              </template>

              <template v-slot:item.DocTotal="{ item }">
                <span>{{ item.DocTotal.toLocaleString() }}</span>
              </template>
            </v-data-table>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    role() {
      return localStorage.getItem("userRole");
    },
  },
  data() {
    return {
      record: {},
      productsDialog: false,
      salesLoader: false,
      soldItems: [],
      pageItems: 100,
      zeroValue: 0,
      menu1: false,
      menu2: false,
      loader: false,
      search: null,
      customers: [],
      reportData: [],
      headers: [
        { text: "Date", value: "DocDate" },
        { text: "Total", value: "DocTotal" },
        { text: "Action", value: "action" },
      ],
    };
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getReport() {
      const data = this.record;
      const url = "/query/ojdt";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
</style>